import React, { Component, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar,
} from '@material-ui/core'
import CommonServiceApi from '../../services/common-service'
import { isString } from 'lodash'
import { Alert } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany'

export default function RedisCacheList() {   
    const [module, setModule] = useState('');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const apiservices = new CommonServiceApi();
    const handleChange = (e: any) => {
        switch (e.target.value) {
            case 1:
                setModule('ticketSettings');
                break;
            case 2:
                setModule('taxSettings');
                break;
            case 3:
                setModule('timecardSettings');
                break;
            case 4:
                setModule('customerSettings');
                break;
            case 5:
                setModule('genericSettings');
                break;
            case 6:
                setModule('invoiceSettings');
                break;
            case 7:
                setModule('invoicePDFSettings');
                break;
            case 8:
                setModule('callIntegrationSettings');
                break;
            case 9:
                setModule('quickbookSettings');
                break;
            case 10:
                setModule('paymentSettings');
                break;
            case 11:
                setModule('notificationSettings');
                break;
        }
    }
    const confirm = (e: any) => {
        var companyId = localStorage.getItem('selectedCompanyId');
        if (module && companyId) {
            let res = `This operation will rebuild redis cache of ${module}. Are you sure?`
            setDialog(true);
            setConfirmMsg(res);
        }
        else {
            setErrorDialog(true);
        }
        return
    }
    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Rebuild Cancelled.`);
    }
    const sync = async () => {
        let companyId = localStorage.getItem('selectedCompanyId');
        let response = await apiservices.redisCache(companyId, module);
        if (response && isString(response)) {
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Cache Rebuilt Successfully.")
        }
        else {
            let msg;
            if (response && response.message && response.description) {
                msg = `Cache Rebuild Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Cache Rebuild Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);
        }
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    return (
        <>
            <SRCards />
            <Container>
            <SelectCompany/>
            <br/><br/>
                <Button className='rediscache_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Rebuild Redis Cache</Button>
                <br></br><br></br>
                <FormControl fullWidth className='rediscache_body'>
                    <InputLabel id="demo-simple-select-label">Modules</InputLabel>
                    <Select
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Ticket</MenuItem>
                        <MenuItem value={2}>Tax</MenuItem>
                        <MenuItem value={3}>Timecard</MenuItem>
                        <MenuItem value={4}>Customer</MenuItem>
                        <MenuItem value={5}>Generic</MenuItem>
                        <MenuItem value={6}>Invoice</MenuItem>
                        <MenuItem value={7}>Invoice PDF</MenuItem>
                        <MenuItem value={8}>Call Integration</MenuItem>
                        <MenuItem value={9}>Quickbook</MenuItem>
                        <MenuItem value={10}>Payment</MenuItem>
                        <MenuItem value={11}>Notification</MenuItem>
                    </Select>
                </FormControl>
                <br /> <br /> <br /> <br />
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    sync()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please select Company and Table before rebuilding the redis cache.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
